import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getPrintingPlanList = createAsyncThunk("/get-PrintingPlan-list", async (data, { rejectWithValue }) => {
  // const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}printingPlan/api/v1/searchPrintingPlan`, data, {
      headers: {
        "Content-Type": "application/json",
      }
    });
    console.log("API Response:", response);
    return response.data; 
  } catch (error) {
    console.error("Error fetching Printing Plan List", error);
    return rejectWithValue(error.response?.data?.message || "Failed to fetch Printing Plan List");
  }
});